import { DownloadResponse } from 'api/APIRest';
import { downloadFile } from './downloadFile';

export const downloadBlobFile = (response: DownloadResponse) => {
  const url = window.URL.createObjectURL(response.file);

  downloadFile(url, response.filename);
};
